export const convexUrl = import.meta.env.VITE_CONVEX_URL || "";
export const brandfetchClientId = import.meta.env.VITE_BRANDFETCH_CLIENT_ID || "";
export const brandfetchApiKey = import.meta.env.VITE_BRANDFETCH_API_KEY || "";
export const oneSignalAppId = import.meta.env.VITE_ONESIGNAL_APP_ID || "";
export const revenueCatAppleKey = import.meta.env.VITE_REVENUECAT_APPLE_API_KEY || "";
export const revenueCatAndroidKey = import.meta.env.VITE_REVENUECAT_ANDROID_API_KEY || "";
export const revenueCatEntitlementId = import.meta.env.VITE_REVENUECAT_ENTITLEMENT_ID || "premium";
export const supportUrl = import.meta.env.VITE_SUPPORT_URL || "mailto:nivoaiapp@gmail.com";
export const privacyUrl = import.meta.env.VITE_PRIVACY_URL || "/legal/privacy";
export const termsUrl = import.meta.env.VITE_TERMS_URL || "/legal/terms";
export const onboardingAnalyticsDashboardSecret =
  import.meta.env.VITE_ONBOARDING_ANALYTICS_DASHBOARD_SECRET || "";

export const ONBOARDING_ANALYTICS_DASHBOARD_PATH = "/internal/onboarding-analytics";
